import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import Counter from "../components/Counter";
import { STATS, PROOF } from "../data/content";

export default function StatsProofSection() {
  return (
    <section className="border-y border-black/5 bg-[#fafafa]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 0.08}>
              <div className={`px-0 lg:px-10 py-8 lg:py-2 border-t border-black/10 lg:border-t-0 lg:border-l ${i === 0 ? "lg:border-l-0 lg:pl-0" : ""}`} data-testid={`stat-${i}`}>
                <div className="font-display text-6xl md:text-7xl tracking-tighter font-medium leading-none tabular-nums">
                  <Counter value={s.num} suffix={s.suffix} />
                </div>
                <p className="mt-5 text-sm text-neutral-500 leading-relaxed max-w-[200px]">{s.label}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-16 md:mt-20 pt-12 border-t border-black/10" data-testid="proof-band">
            <p className="text-sm text-neutral-400 mb-8">Real outcomes, from real businesses we've kept anonymous</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-10">
              {PROOF.map((p, i) => (
                <Reveal key={i} delay={i * 0.06}>
                  <Link to={`/portfolio/${p.slug}`} className="group block" data-testid={`proof-${i}`}>
                    <div className="font-display text-2xl md:text-3xl tracking-tight font-medium leading-tight transition-transform duration-300 group-hover:-translate-y-0.5">{p.outcome}</div>
                    <div className="mt-3 flex items-center gap-2 text-sm text-neutral-500 group-hover:text-black transition-colors">
                      <span className="h-px w-5 bg-neutral-400 transition-all duration-300 group-hover:w-8 group-hover:bg-black" />
                      {p.who}
                      <ArrowUpRight size={15} className="opacity-0 -translate-x-1 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0" />
                    </div>
                  </Link>
                </Reveal>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
